import _ from 'lodash';
import moment from 'moment';

export const composeBarChartData = (data, fields, labelField, labelSuffix) => fields.map(field =>
  data.map(row =>
    ({
      x: row[labelField].toString(),
      y: row[field],
      label: labelSuffix ? `${row[field]} ${labelSuffix}` : row[field],
    })));

export const shortenDateLabels = (data, dateField) => _.map(data, (row) => {
  const check = moment(row[dateField]);
  return `${check.format('DD')}/${check.format('MM')}/${check.format('YYYY')}`;
});

const interchangeProcessing = {
  title: 'Interchange Processing',
  type: 'stackedColumn',
  fields: [{
    name: 'Interchanges',
    color: '#2f89bd',
  }, {
    name: 'On hold',
    color: '#efa514',
  }, {
    name: 'Pending translation',
    color: '#555452',
  }, {
    name: 'Accepted',
    color: '#efd624',
  }, {
    name: 'Translated',
    color: '#3724ef',
  }, {
    name: 'Translation rejected',
    color: '#00ef4c',
  }, {
    name: 'Not loaded',
    color: '#7c78ef',
  }, {
    name: 'Missing',
    color: '#ef1810',
  }],
  yTickFormat: amount => amount,
  xTickValues: data => shortenDateLabels(data, 'onNetworkDate'),
  composeChartData: data => composeBarChartData(
    data,
    ['interchanges', 'onHold', 'pendingTranslation', 'accepted', 'translated', 'translationRejected', 'notLoaded', 'missing'],
    'onNetworkDate',
  ),
};

export default {
  interchangeProcessing,
};
